import React from "react";

const STATUS_CLASS_MAP = {
  success: "merchant-status-ok",
  completed: "merchant-status-ok",
  partial_refund: "merchant-status-warn",
  entire_refund: "merchant-status-error",
  cancel: "merchant-status-warn",
  cancelled: "merchant-status-warn",
  fail: "merchant-status-error",
  failed: "merchant-status-error",
  ready: "merchant-status-ok",
  enabled: "merchant-status-ok",
  active: "merchant-status-ok",
  pending: "merchant-status-warn",
};

const STATUS_LABEL_MAP = {
  success: "Completed",
  completed: "Completed",
  partial_refund: "Partial Refund",
  entire_refund: "Entire Refund",
  cancel: "Canceled",
  cancelled: "Canceled",
  fail: "Failed",
  failed: "Failed",
  ready: "Ready",
  enabled: "Enabled",
  active: "Active",
  pending: "Pending",
};

export default function MerchantStatusBadge({ status, label }) {
  const normalizedStatus = String(status || "").toLowerCase();
  const className = STATUS_CLASS_MAP[normalizedStatus] || "merchant-status-error";

  return (
    <span className={"merchant-status " + className}>
      <span className="merchant-status-dot" />
      {label || STATUS_LABEL_MAP[normalizedStatus] || status}
    </span>
  );
}
